import { Flex, Modal, Select } from 'antd'
import Order from '../../types/api/order'

export type ChooseOpenOrderResult =
    | { kind: 'existing'; documentId: string }
    | { kind: 'new' }

type ChooseOpenOrderOptions = {
    productLabel: string
}

export function chooseOpenOrder(
    orders: Order[],
    options: ChooseOpenOrderOptions
): Promise<ChooseOpenOrderResult> {
    const { productLabel } = options

    if (orders.length === 0) {
        return Promise.resolve({ kind: 'new' })
    }

    if (orders.length === 1) {
        const only = orders[0]
        return new Promise(resolve => {
            Modal.confirm({
                title: `Добавить в существующий заказ №${only.id}?`,
                okText: 'Да',
                cancelText: 'Нет, создать новый',
                centered: true,
                zIndex: 1100,
                onOk: () => {
                    resolve({ kind: 'existing', documentId: only.documentId })
                },
                onCancel: () => {
                    resolve({ kind: 'new' })
                },
            })
        })
    }

    return new Promise(resolve => {
        let selectedDocId = orders[0].documentId

        Modal.confirm({
            title: 'Выберите заказ',
            content: (
                <div>
                    <p>У клиента несколько открытых заказов. Куда добавить {productLabel}?</p>
                    <Select
                        defaultValue={selectedDocId}
                        options={orders.map(order => ({
                            value: order.documentId,
                            label: `Заказ №${order.id}`,
                        }))}
                        onChange={value => {
                            selectedDocId = value
                        }}
                    />
                </div>
            ),
            okText: 'Добавить в выбранный',
            cancelText: 'Создать новый заказ',
            width: 480,
            centered: true,
            zIndex: 1100,
            footer: (_, { OkBtn, CancelBtn }) => (
                <Flex justify='flex-end' wrap='wrap'>
                    <CancelBtn />
                    <OkBtn />
                </Flex>
            ),
            onOk: () => {
                resolve({ kind: 'existing', documentId: selectedDocId })
            },
            onCancel: () => {
                resolve({ kind: 'new' })
            },
        })
    })
}
